<div class="lp-canvas-components" style="position: relative; width: 100%; height: 100%">
  @for (comp of components(); track $index) {
    <div style="position: absolute; inset: 0">
      @switch (comp.dataType) {
        @case ('ConditionalVisibilityCanvasComponent') {
          <lp-conditional-visibility-canvas-component [comp]="comp" [context]="context()" />
        }
        @case ('DraggableCanvasComponent') {
          <lp-draggable-canvas-component [comp]="comp" [context]="context()" />
        }
        @case ('DropTargetCanvasComponent') {
          <lp-drop-target-canvas-component [comp]="comp" [context]="context()" />
        }
        @case ('IfCanvasComponent') {
          <lp-if-canvas-component [comp]="comp" [context]="context()" />
        }
        @case ('ImageCanvasComponent') {
          <lp-image-canvas-component [comp]="comp" />
        }
        @case ('OnClickCanvasComponent') {
          <lp-on-click-canvas-component [comp]="comp" [context]="context()" />
        }
        @case ('ParallaxCanvasComponent') {
          <lp-parallax-canvas-component [comp]="comp" [context]="context()" />
        }
        @case ('SolidColorCanvasComponent') {
          <lp-solid-color-canvas-component [comp]="comp" [context]="context()" />
        }
        @case ('TextCanvasComponent') {
          <lp-text-canvas-component [comp]="comp" [context]="context()" />
        }
        @case ('OnTriggerCanvasComponent') {
          <lp-on-trigger-canvas-component [comp]="comp" [context]="context()" />
        }
        @case ('WebStyleSheetImageCanvasComponent') {
          <lp-web-style-sheet-image-canvas-component [comp]="comp" />
        }
        @case ('Wk8BookContentsCanvasComponent') {
          <wk8-book-contents-canvas-component [comp]="comp" [context]="context()" />
        }
        @default {
          {{ logUnsupported(comp) }}
        }
      }
    </div>
  }
</div>
